// @ts-nocheck
import * as React from "react"

const THEMEURL = window.drupalSettings ? window.drupalSettings.path.themeUrl : 'themes/custom/mx_aguas_firmes_theme';

// Components
import Loader from "../Loader";
import { FishSec } from "../Animals";
import { SkySec } from "../BgAnimation";
import BtnSumate from "../BtnSumate"
import CardBlockBlog from "../CardBlockBlog"
import TitleAnimate from "../TitleAnimate";
import ScrollAnimation from "../ScrollAnimation";

const textFilter: any = {
    es: {
        filter: "Filtrar por",
        date: "Fecha",
        title: "Título"
    },
    en: {
        filter: "Filter by",
        date: "Date",
        title: "Title"
    }
}

export const Blog = ({ data, setLoading, loading }: BlogCmp) => {
    const [orderList, setOrderList] = React.useState<any>(data.articles)

    const orderBy = (e) => {
        let field = e.target.value
        let nwOrder = orderList.sort((a, b) => {
            if (a[field] > b[field]) return 1;
            if (a[field] < b[field]) return -1;
        })
        setOrderList([...nwOrder]);
    }

    React.useEffect(() => {
        window.onload = function () {
            setLoading(false)
        }
    }, []);

    return (
        <main className="blog">
            <div className="blog__banner">
                <SkySec desk={{ url: `/${THEMEURL}/sources/dist/assets/images/blog/bg_headerBlog.jpg` }} mobile={{ url: `/${THEMEURL}/sources/dist/assets/images/blog/bg_headerBlog.jpg` }} />
                <div className="blog__banner-title">
                    <h1 ><TitleAnimate text={!loading ? data.title : ''} /></h1>
                    {!loading && <p className="page__banner-description" dangerouslySetInnerHTML={{ __html: data.desc_head }} data-aos='fade-up' data-aos-delay='2000'></p>}
                </div>
                <div className="blog__banner-dropdown-container">
                    <select className='blog__banner-filter blog__banner-filter--desk' name="filterDesk" id="filterDesk" onChange={orderBy}>
                        <option value>{textFilter[window.currentLang].filter}</option>
                        <option value='date'>{textFilter[window.currentLang].date}</option>
                        <option value='field_titlemain'>{textFilter[window.currentLang].title}</option>
                    </select>
                </div>
                <div className="blog__banner-sumate">
                    {!loading && <BtnSumate />}
                </div>
                {!loading && <ScrollAnimation delay={2500} />}
            </div>
            <div className="blog__content">
                {/* <FishSec /> */}
                <div className="blog__content-btn" data-aos="fade-down" data-aos-duration="1000">
                    <select className='blog__banner-filter blog__banner-filter--mob' name="filterMob" id="filterMob" onChange={orderBy}>
                        <option value>{textFilter[window.currentLang].filter}</option>
                        <option value='date'>{textFilter[window.currentLang].date}</option>
                        <option value='field_titlemain'>{textFilter[window.currentLang].title}</option>
                    </select>
                </div>
                <CardBlockBlog articleList={orderList} btnMore={data.field_more} />
            </div>
        </main>
    )
}

export default Loader(Blog)